import React from 'react';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';

const InputLoanUsageType = () => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="loanUsageType"
      control={control}
      rules={{ required: 'This field is required.' }}
    >
      <TextField
        select
        fullWidth
        label="Reason for Applying"
        SelectProps={{ native: true }}
      >
        <option value="" disabled aria-label="blank option" />
        <option value="REPAIR">Service / Repair</option>
        <option value="DOWN_PAYMENT_ASSIST">Down Payment Assistance</option>
        <option value="FINANCE_AND_INSURANCE">Finance & Insurance</option>
      </TextField>
    </ValidatedTextField>
  );
};

export default InputLoanUsageType;
